import React from "react";
import { Mail, Phone, Instagram, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/courseData";

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-white/10 bg-[#141414] mt-24"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2 space-y-5">
        <img src="/rl-logo.png" alt="RL Trading Institute" className="h-14 w-auto" />
        <p className="text-white/70 text-sm max-w-md leading-relaxed">
          Complete Stock Market Course (A to Z) — learn the stock market from zero to consistent trader
          with live examples and battle-tested supply/demand strategies.
        </p>
      </div>

      <div>
        <div className="tracking-overline text-[10px] text-white/40 mb-4">Explore</div>
        <ul className="space-y-2.5 text-sm">
          <li><a href="#curriculum" className="text-white/70 hover:text-fin-green">Curriculum</a></li>
          <li><a href="#pricing" className="text-white/70 hover:text-fin-green">Fees</a></li>
          <li><a href="#mentor" className="text-white/70 hover:text-fin-green">Mentor</a></li>
          <li><a href="#contact" className="text-white/70 hover:text-fin-green">Contact</a></li>
        </ul>
      </div>

      <div>
        <div className="tracking-overline text-[10px] text-white/40 mb-4">Contact</div>
        <ul className="space-y-2.5 text-sm">
          <li className="flex items-center gap-2 text-white/80">
            <Mail className="h-4 w-4 text-fin-green" />
            <a href="mailto:rltradinginstitute@gmail.com" className="hover:text-fin-green">
              rltradinginstitute@gmail.com
            </a>
          </li>
          <li className="flex items-center gap-2 text-white/80">
            <Phone className="h-4 w-4 text-fin-green" />
            <a href="tel:+917276863734" className="hover:text-fin-green">+91 72768 63734</a>
          </li>
          <li className="flex items-center gap-2 text-white/80">
            <MessageCircle className="h-4 w-4 text-fin-green" />
            <a
              href={WHATSAPP_URL}
              data-testid="footer-whatsapp"
              target="_blank"
              rel="noreferrer"
              className="hover:text-fin-green"
            >
              WhatsApp us
            </a>
          </li>
          <li className="flex gap-3 pt-1">
            <a href="https://www.instagram.com/rlt_pune?dlrf=emwwZ2c4dWt1cHFn" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="text-white/60 hover:text-fin-green"><Instagram className="h-5 w-5" /></a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <div>© {new Date().getFullYear()} RL Trading Institute. All rights reserved.</div>
        <div className="font-mono">Investing involves risk. Educational content only, not financial advice.</div>
      </div>
    </div>
  </footer>
);

export default Footer;
